import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Btn = styled(Button)`
    padding-left: 0;
    padding-right: 0;
`;

export const StepProgress = styled.div`
    flex-direction: column;
    width: 100%;
`;

export const HeaderWrap = styled.div`
    height: 32px;
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
    column-gap: 4px;
    color: ${COLORS.TextInfo};
    position: relative;
  
    svg {
        g#guts {
            stroke: ${COLORS.TextInfo};
        }
    }
  
    ${ControlElement}{
        position: absolute;
        right: 0;
    }
`;

export const BtnWrap = styled.div`
    cursor: pointer;
    &:hover {
        transform: scale(1.1);
    }
`;

export const ImgWrap = styled.div`
    width: 54px;
    height: 32px;
    margin-left: auto;
    overflow: hidden;

    picture {
        width: auto;
        height: 100%;
    }

    img {
        width: auto;
        height: 100%;
    }
`;
